import { Select, Skeleton } from 'antd';
import { CompetencyItem } from '../types/competenciesTypes';

interface SkillAlignmentCompProps {
  isLoading?: boolean;
  skills: CompetencyItem[];
  onLevelChange: (value: number, id: number) => void;
  formData: { id: number; score: number | null; question: string }[];
  disabled?: boolean;
}

export default function SkillAlignmentComp({
  isLoading,
  skills,
  formData,
  onLevelChange,
  disabled,
}: SkillAlignmentCompProps) {
  if (isLoading) {
    return (
      <>
        <h3 className="text-lg font-medium mb-4">
          <Skeleton.Input style={{ width: 150 }} active size="small" />
        </h3>
        <div className="flex flex-col gap-y-6">
          {[1, 2, 3].map((key) => (
            <div key={key} className="space-y-2">
              <div className="font-medium">
                <Skeleton.Input style={{ width: 200 }} active size="small" />
              </div>
              <div className="text-sm text-gray-600 mb-2">
                <div>
                  <Skeleton.Input style={{ width: 250 }} active size="small" />
                </div>
                <div className="text-gray-500">
                  <Skeleton.Input style={{ width: 300 }} active size="small" />
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="bg-[#F8FBFF] p-4 rounded-lg flex-1">
                  <div className="text-sm mb-2">
                    <Skeleton.Input
                      style={{ width: 250 }}
                      active
                      size="small"
                    />
                  </div>
                  <div className="text-sm text-gray-500">
                    <Skeleton.Input
                      style={{ width: 300 }}
                      active
                      size="small"
                    />
                  </div>
                </div>
                <Skeleton.Input style={{ width: 200 }} active size="small" />
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="flex flex-col gap-y-6">
        {skills &&
          skills.length > 0 &&
          skills.map((skill, index) => {
            const skillData = formData.find(
              (item) => item.id === skill.statement.id
            );

            const length = 10;

            // skillData?.score === 0 &&
            //   onLevelChange(skill.expected.skillLevel, skill.statement.id);

            const options = Array.from({ length }, (_, index) => {
              const value = index * 0.5 + 0.5;
              const label =
                value % 1 === 0.5
                  ? `Level ${Math.floor(value)} (+)`
                  : `Level ${value}`;
              if (value === 0.5) {
                return { value, label: 'Level 1 (-)' };
              }
              return { value, label };
            });

            const findScore = () => {
              const score = formData.find(
                (x) => x.id === skill.statement.id
              )?.score;

              if (score === 0.5) {
                return 1;
              } else if ((score as number) % 1 === 0) {
                return score;
              } else if ((score as number) % 1 === 0.5) {
                return (score as number) - 0.5;
              }
            };

            return (
              <div key={index} className="space-y-2">
                <div className="text-lg font-semibold">
                  {skill.statement.description}
                </div>

                <div className="flex justify-between items-start gap-3">
                  <div className="text-md  text-gray-500 mb-2">
                    <div>
                      <b>
                        Expected Level (Level {skill.expected.skillLevel}) :
                      </b>{' '}
                      {skill.expected.description}
                    </div>
                  </div>
                  <div>
                    <Select
                      value={
                        skillData?.score === 0
                          ? skill.expected.skillLevel
                          : skillData?.score
                      }
                      placeholder="Select Level"
                      style={{ width: 120 }}
                      onChange={(value) =>
                        onLevelChange(value, skill.statement.id)
                      }
                      disabled={disabled}
                      options={options.map((item) => ({ ...item }))}
                    />
                  </div>
                </div>

                {skillData?.score !== skill.expected.skillLevel &&
                  skillData?.score !== 0 &&
                  skillData?.score !== null && (
                    <div
                      className={`${disabled ? 'bg-[#F5F5F5] border-2 border-[#616161]' : 'bg-[#E6F7FF] border-2 border-[#91D5FF]'} rounded-sm p-3`}
                    >
                      <div className="text-md text-gray-500 ">
                        <div>
                          <b>
                            Level Assigned to Mentee (Level {findScore()}) :
                          </b>{' '}
                          {
                            skill.descriptions.find(
                              (item) => item.skillLevel === findScore()
                            )?.description
                          }
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            );
          })}
      </div>
    </>
  );
}
